import React, { useEffect, useState } from 'react';
import { normalizeId } from '../helpers/utility';
import Video from '../../components/common/Video';

const VideoInput = field => {
    const { id, title, required, preValue, disabled, containerClassName = '', ...rest } = field;
    const inputId = id || normalizeId(title);
    const [videos, setVideos] = useState(Array.isArray(preValue) ? preValue : preValue ? [preValue] : []);

    useEffect(() => {
        if (Array.isArray(preValue)) {
            setVideos(preValue);
        } else if (preValue) {
            setVideos([preValue]);
        }
    }, [preValue]);

    const handleVideosChange = newVideos => {
        setVideos(newVideos);
    };

    return (
        <>
            <Video
                videos={videos}
                onVideosChange={handleVideosChange}
                isEditMode={!disabled}
                containerClassName={containerClassName}
                showTitle={false}
                {...rest}
            />
            <input
                type="hidden"
                id={inputId}
                name={inputId}
                required={required}
                value={videos && videos.length ? JSON.stringify(videos) : ''}
                readOnly
            />
        </>
    );
};

export default VideoInput;
